import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MetricsWidgetComponent } from './metrics-widget/metrics-widget.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SharedModule } from '../shared.module';
import { VisitCounterWidgetComponent } from './visit-counter-widget/visit-counter-widget.component';
import { UnscheduledBatchesWidgetComponent } from './batches-widget/unscheduled-batches-widget.component';


@NgModule({
  declarations: [
    MetricsWidgetComponent,
    VisitCounterWidgetComponent,
    UnscheduledBatchesWidgetComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatButtonToggleModule,
    MatInputModule,
    MatButtonToggleModule,
    MatSelectModule,
    MatTooltipModule,
    MatIconModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    SharedModule,
  ],
  exports: [
    MetricsWidgetComponent,
    VisitCounterWidgetComponent,
    UnscheduledBatchesWidgetComponent,
  ],
})
export class WidgetsModule {
}

